<div class="esign-templates">
  <header class="esign-templates__head">
    <h2 class="mb-0">ESign templates</h2>
    @if (hasValidEditPermission()) {
      <button
        type="button"
        class="btn btn-outline btn-sm"
        (click)="addEditTemplate()"
      >
        <i class="bi bi-plus-lg me-1"></i>
        Add template
      </button>
    }
  </header>

  <div class="esign-templates__grid">
    <app-esign-templates-grid
      [gridName]="'AdminESignTemplates'"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      [TooltipMap]="TooltipMap"
      [suppliedQueryData]="SuppliedGridQuery"
      (actionEvent)="action($event)"
      [suppressFieldDotNotation]="false"
      [(reloadGridData)]="reloadGrid"
    ></app-esign-templates-grid>
  </div>
</div>
